import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit';
import { IconProductKey24, IconActionChevronRight16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

interface IMyHomeTrapBannerProps {
  href: string;
  onClick: () => void;
}

export const MyHomeTrapBanner: React.FC<IMyHomeTrapBannerProps> = ({ href, onClick }) => {
  return (
    <a className={styles['container']} href={href} onClick={onClick}>
      <div className={styles['wrapper']}>
        <div className={styles['key-icon']}>
          <IconProductKey24 color="icon-primary-default" />
        </div>

        <div>
          <ArticleHeading4 color="text-primary-default">Живёте здесь? Добавьте адрес в Мой дом.</ArticleHeading4>
          <ArticleParagraph2 color="icon-secondary-default">
            Сможете следить, как меняется цена вашей квартиры
          </ArticleParagraph2>
        </div>
      </div>

      <div>
        <IconActionChevronRight16 color="icon-secondary-default" />
      </div>
    </a>
  );
};
